const competitionFilterStyles = (theme) => ({
  formControl: {
    minWidth: 200,
  },
  searchHeader: {
    backgroundColor: theme.palette.background.paper,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    lineHeight: 'normal',
  },
  noResults: {
    position: 'static',
    fontStyle: 'italic',
  },
})

export default competitionFilterStyles
